import { createSlice } from '@reduxjs/toolkit';
import { scrollLock as ScrollLock, scrollUnlock as ScrollUnlock } from './scrollLock';

const initialState = {
  privacyMode: false,
  collectMode: false,
  useMode: false,
  collectAgree: false,
  useAgree: false,
  collectContent: '',
  useContent: '',
};

export const popupSlice = createSlice({
  name: 'popup',
  initialState,
  reducers: {
    showPrivacy: (state) => {
      state.privacyMode = true;
      ScrollLock();
    },
    showCollect: (state) => {
      state.collectMode = true;
      ScrollLock();
    },
    showUse: (state) => {
      state.useMode = true;
      ScrollLock();
    },
    popupHide: (state) => {
      state.privacyMode = false;
      state.collectMode = false;
      state.useMode = false;
      ScrollUnlock();
    },
    agreeCollect: (state, { payload }) => {
      state.collectMode = false;
      state.collectAgree = true;
      state.collectContent = payload;
      ScrollUnlock();
    },
    disagreeCollect: (state) => {
      state.collectMode = false;
      state.collectAgree = false;
      state.collectContent = '';
      ScrollUnlock();
    },
    agreeUse: (state, { payload }) => {
      state.useMode = false;
      state.useAgree = true;
      state.useContent = payload;
      ScrollUnlock();
    },
    disagreeUse: (state) => {
      state.useMode = false;
      state.useAgree = false;
      state.useContent = '';
      ScrollUnlock();
    },
    /**
     * 접수가 완료된 뒤 동의 상태를 되돌립니다.
     * 체크박스는 이 스토어를 보고 그려지므로, 폼 로컬 state 만 비우면 체크가 남습니다.
     * 동의는 접수 1건에 대한 것이니 다음 문의 때 다시 받아야 합니다.
     */
    resetAgree: (state) => {
      state.collectAgree = false;
      state.useAgree = false;
      state.collectContent = '';
      state.useContent = '';
    },
  },
});

export const {
  showPrivacy,
  showCollect,
  showUse,
  popupHide,
  agreeCollect,
  disagreeCollect,
  agreeUse,
  disagreeUse,
  resetAgree,
} = popupSlice.actions;

export default popupSlice.reducer;
